// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"15dd423d","115":"35280eed"}[chunkId] + ".chunk.js";
};